// src/components/HelpButton.js
// vHELPBTN-001
import React from "react";

export default function HelpButton({ topic, title = "Open Help" }) {
  function openHelp() {
    const cleanTopic = String(topic || "").trim();
    const query = cleanTopic ? `?onderwerp=${encodeURIComponent(cleanTopic)}` : "";
    window.location.href = `/help${query}`;
  }

  return (
    <button
      type="button"
      onClick={openHelp}
      title={title}
      aria-label={title}
      style={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: "1px solid #1f4e79",
        background: "white",
        color: "#1f4e79",
        fontSize: 17,
        fontWeight: 700,
        lineHeight: 1,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        flex: "0 0 auto",
      }}
    >
      ?
    </button>
  );
}
